import { useFragment, useQuery } from '@apollo/client/react'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { graphql } from '@/gql'
import { Toggle } from '../item_type_connector_family/toggle'
import { ItemTypeConnectorFamiliesQuery } from '@/pages/item_types/connector_families'

export const ItemTypeConnectorFamiliesFragment = graphql(`
  fragment ItemTypeConnectorFamiliesDetail on ItemTypeType {
    id
    name
    itemTypeConnectorFamilies {
      id
      connectorFamily { id name connectors { count } connectorFamilyPins { id name role } }
    }
  }
`)

const ConnectorFamiliesQuery = graphql(`
  query ItemTypeConnectorFamiliesOptions {
    connectorFamilies(first: 50) {
      nodes {
        id
        name
        connectors { count }
        connectorFamilyPins { id name role }
      }
    }
  }
`)

interface Props {
  id: string
}

export const ItemTypeConnectorFamilies = ({ id }: Props) => {
  const { data: connectorFamilies, loading } = useQuery(ConnectorFamiliesQuery)

  const { data: existingConnectorFamilies, complete } = useFragment({
    fragment: ItemTypeConnectorFamiliesFragment,
    from: { __typename: 'ItemTypeType', id },
  })

  if (!complete || loading) return <LoadingSkeleton table />

  const mergedConnectorFamilies = connectorFamilies?.connectorFamilies.nodes?.map(cf => {
    const existingCF = existingConnectorFamilies.itemTypeConnectorFamilies.find(itcf => itcf.connectorFamily.id === cf.id)
    if (existingCF) {
      return { ...cf, existingId: existingCF.id }
    } else {
      return { ...cf, existingId: undefined }
    }
  })

  return (
    <>
      { mergedConnectorFamilies && <div className="flex flex-col grow">
        <div className="flex flex-row flex-wrap gap-3">
          { mergedConnectorFamilies.map(itcf => <Toggle connectorFamily={ itcf } itemTypeConnectorFamilyId={ itcf.existingId } itemTypeId={ id } refetchQueries={ [ItemTypeConnectorFamiliesQuery] } />) }
        </div>
      </div> }
    </>
  )
}
